import React, { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export default function SizeField({
  value,
  onChange,
  llm_configs,
  family,
  disabled = false,
  error = false,
}) {
  const sizes = useMemo(() => {
    if (!family) return [];
    return Object.keys(llm_configs?.[family]?.sizes || {});
  }, [family, llm_configs]);

  return (
    <FormControl fullWidth disabled={disabled || !family} error={error}>
      <InputLabel id='endpoint-llm-size-label'>Model Size</InputLabel>
      <Select
        labelId='endpoint-llm-size-label'
        label='Model Size'
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        {sizes.map((size) => (
          <MenuItem key={size} value={size}>
            {size}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

